export const JSON_ONE11 = {
   
  
    "header": {
    "operatingSystem": "andriod",
    "sessionId": "AGGR001158",
    "version": "1.0.0"
    },
    "userInfo": { },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "BENEF",
    "transCode": "0",
    "transAmt": "0.00"
    },
    "payOutBean": {
    "mobileNo": "7974845996",
    "accountNo": "119601523756",
    "ifscCode": "ICIC0001196",
    "accountHolderName": "ABC",
    "txnType": "BANK",
    "nickName": "CFG"
    }
    }

export const JSON_TWO12 = {
    
  
    "header": {
    "ipAddress": "192.168.1.147",
    "userAgent": "Mozilla/5.0 Chrome/80.0.3987.132 36",
    "operatingSystem": "WEB",
    "sessionId": "1e2e5448c78d59725669d1719d36d44ee3faa85",
    "version": "1.0.0"
    },
    "transaction": {
    "requestType": "WTW",
    "requestSubType": "PBENE",
    "tranCode": 0,
    "txnAmt": 0,
    "id": "AGGR001158"
    },
    "payOutBean": {
    "mobileNo": "7879455898",
    "txnAmount": "2",
    "beneId": "BENE001018"
    }
    }

export const JSON_THREE13 = {
    
  
    "header": {
    "operatingSystem": "andriod",
    "sessionId": "AGGR001158"
    },
    "transaction": {
    "requestType": "TMH",
    "requestSubType": "STCHK"
    },
    "payOutBean": {
    "payoutId": "PAYO001229"
    }
    }























    